import type { SxProps, Theme } from '@mui/material'

export const featureDisabledStyles: Record<string, SxProps<Theme>> = {
  root: {
    height: '100%',
    minHeight: 400,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: 480,
    textAlign: 'center',
  },
  iconContainer: {
    width: 60,
    height: 60,
    backgroundColor: 'gray.3',
    borderRadius: '50%',
    marginBottom: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    color: 'gray.40',
    marginLeft: 0.5,
    marginTop: 0.5,
  },
  description: {
    marginBottom: 2,
    marginTop: 1,
  },
}
